(function() {
    $(document).ready(function() {
        $('.mod24LeadForm .c24Tooltip.help').on('click', function() {
            const $this = $(this);
            if ($this.hasClass('active')) {
                $this.removeClass('active');
            } else {
                $('.c24Tooltip.help', $this.closest('.mod24LeadForm')).removeClass('active');
                $this.addClass('active');
            }
        });
    });
})();
